import { render, staticRenderFns } from "./product-rules-summary.component.vue?vue&type=template&id=b32dbef8&"
import script from "./product-rules-summary.component.ts?vue&type=script&lang=ts&"
export * from "./product-rules-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./product-rules-summary.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
